module.exports = __webpack_public_path__ + "static/media/HY_Logo.27ea3fed.webp";